import { VideoCardData } from '@tenants/types/tenant';

export const videoCardData: readonly VideoCardData[] = [
  {
    videoId: 'hv5oA6q_phM',
    bottomText: 'A model with no limits',
  },
  {
    videoId: 'AA76L8hw7oU',
    bottomText: '"Fresh and exciting adventure in real estate"',
  },
  {
    videoId: 'pGH14z9XpRc',
    bottomText: 'Where top-producing teams find their future',
  },
  {
    videoId: 'vK24zkG4C0k',
    bottomText: '"eXp isn\'t just where I\'ll do business—it\'s where I\'ll be growing alongside the best in the industry."',
  },
  {
    videoId: 'VdulH47weDY',
    bottomText: 'A new chapter begins.',
  },
  {
    videoId: 'H_DP7Pmme0s',
    bottomText: '"Where everything feels just right"',
  },
  {
    videoId: 'xcx9cySzqFY',
    bottomText: 'From MMA champion to real estate leader',
  },
  {
    videoId: 'x0dZCrsGBAw',
    bottomText: '"Aligning values with purpose, building a life that matters"',
  },
] as const;